module.exports = __webpack_public_path__ + "static/media/rsAnimeOP2.f1aef1e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/rsAnimeOP2.jpg
// module id = 567
// module chunks = 0